<template>
  <v-stepper
    v-model="step"
    :class="{ 'dark-mode': isDark }"
    non-linear
    class="mb-3 br-10"
  >
    <v-stepper-header ref="formHeader">
      <v-stepper-step editable step="1">
        {{i18n('Identificação')}}
      </v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step editable step="2">
        {{i18n('Sócios')}}
      </v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step editable step="3">
        {{i18n('Documentos')}}
      </v-stepper-step>
      <v-divider v-if="show_bank_accounts_tab"></v-divider>
      <v-stepper-step :step="accounts_step_number" v-if="show_bank_accounts_tab" :editable="step > 3 || operation == 'update'">
        {{i18n('Canais Bancários')}}
      </v-stepper-step>
      <v-divider v-if="show_users_tab"></v-divider>
      <v-stepper-step editable :step="users_step_number" v-if="show_users_tab">
        {{ i18n("Usuários") }}
      </v-stepper-step>
      <v-divider v-if="show_approval_tab"></v-divider>
      <v-stepper-step editable :step="last_step_number" v-if="show_approval_tab && operation == 'create'">
        {{i18n('Criar/Aprovar')}}
      </v-stepper-step>
      <v-stepper-step editable :step="last_step_number" v-if="show_approval_tab && operation == 'update'">
        {{i18n('Atualizar/Aprovar')}}
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-content step="1">
      <v-container class="grid-list-sm cursor-type" @click.prevent.stop="" >
        <v-layout class="row wrap align-center">
          <v-flex v-bind:class="{ xs12: !displayTotals, xs6: displayTotals }" pb-3 display-1 title-form position-relative :dark="isDark">
            {{i18n('Identificação')}}
            <v-snackbar v-model="display_feedback" :timeout="2000" bottom>ID copiado para a área de transferência</v-snackbar>
            <div class="caption no-input-focus title-form width-position ml-1" v-if="operation == 'update'" data-testid="subject-id-label">{{record.id}}
              <v-icon small @click="copyIdtoClipboard" data-testid="copy-subject-id-icon">content_copy</v-icon>
            </div>
          </v-flex>
          <v-flex xs12 sm6 mt-3 text-sm-right subtitle-1 style="color: var(--background-color)" v-if="displayTotals">
            {{i18n('Total movimentado')}}: {{l(this.transactionTotalBRL, 'BRL')}}
          </v-flex>
          <v-flex class="xs6 lg3">
            <v-select
              box
              :label="i18n('Domicílio Fiscal')"
              append-icon="public"
              v-model="record.document_type"
              clearable
              @click:clear="record.document_type = null"
              :items="fiscalCountryItems"
            ></v-select>
          </v-flex>
          <v-flex class="xs12 lg2">
            <v-text-field
            box
            v-model="record.document_number"
            :errorMessages="errorMessagesFor('document_number')"
            :dark="isDark"
            :label="record.document_type.toLowerCase() == 'tax_id' ? 'TAX ID*' : `${record.document_type.toUpperCase()}*`"
            :mask="maskForDocumentNumber(record.document_type)"
            ></v-text-field>
          </v-flex>
          <v-flex class="xs12 lg3">
            <v-text-field
            box
            v-model="record.email"
            :errorMessages="errorMessagesFor('email')"
            :dark="isDark"
            :label="i18n('Email')"
            ></v-text-field>
          </v-flex>
          <v-flex class="xs2 lg1">
            <v-select
              box
              v-model="record.phone_country_code"
              :errorMessages="errorMessagesFor('countryCode')"
              :dark="isDark"
              :label="i18n('Cod. País')"
              :items="getCountryCodes"
              clearable
            ></v-select>
          </v-flex>
          <v-flex class="xs2 lg1">
            <v-text-field
              box
              v-model="record.phone_area_code"
              :errorMessages="errorMessagesFor('areaCode')"
              :dark="isDark"
              :label="i18n('Cod. Área')"
            ></v-text-field>
          </v-flex>
          <v-flex class="xs12 lg2">
            <v-text-field
            box
            v-model="record.phone_number"
            :errorMessages="errorMessagesFor('phone_number')"
            :dark="isDark"
            :label="i18n('Telefone')"
            ></v-text-field>
          </v-flex>
          <v-flex class="xs12 lg4">
            <v-text-field
            box
            v-model="record.social_name"
            :errorMessages="errorMessagesFor('social_name')"
            :dark="isDark"
            :label="i18n('Razão Social')"
            ></v-text-field>
          </v-flex>
          <v-flex class="xs12 lg4">
            <v-text-field
            box
            v-model="record.company_name"
            :errorMessages="errorMessagesFor('company_name')"
            :dark="isDark"
            :label="i18n('Nome Fantasia')"></v-text-field>
          </v-flex>
          <v-flex class="xs12 lg4">
            <v-text-field
              box
              v-model="record.website"
              :errorMessages="errorMessagesFor('website')"
              :dark="isDark"
              :label="i18n('Website')">
            </v-text-field>
          </v-flex>

          <v-flex class="xs12 lg8">
            <v-autocomplete
            v-model="record.main_activity"
            :errorMessages="errorMessagesFor('main_activity')"
            :items="activities"
            :dark="isDark"
            :label="i18n('Atividade Principal')"
            ></v-autocomplete>
          </v-flex>
          <v-flex class="xs12 lg4">
            <v-autocomplete
            v-model="record.fiscal_country"
            :errorMessages="errorMessagesFor('fiscal_country')"
            :items="countries"
            :dark="isDark"
            :label="i18n('País Domicílio Fiscal')"
            ></v-autocomplete>
          </v-flex>
          <v-flex class="xs12 lg3">
            <v-text-field
            box
            :dark="isDark"
            v-model="creationDateFormatted"
            :errorMessages="errorMessagesFor('creation_date')"
            :label="i18n('Data de constituição')"
            mask="##/##/####"
            :return-masked-value=true
            hint="DD/MM/YYYY"
            persistent-hint
            prepend-icon="event"
            ></v-text-field>
          </v-flex>
          <v-flex class="xs12 lg3">
            <v-currency-field class="padding-bottom-liquid"
            v-bind="currency_config"
            box
            :dark="isDark"
            v-model="record.net_value"
            :errorMessages="errorMessagesFor('net_value')"
            :label="i18n('Patrimônio líquido')"
            ></v-currency-field>
          </v-flex>
          <v-flex class="xs12 lg6">
            <v-currency-field
            v-bind="currency_config"
            box
            :dark="isDark"
            v-model="record.net_monthly_average_income"
            :errorMessages="errorMessagesFor('net_monthly_average_income')"
            :label="i18n('Faturamento médio mensal')"
            persistent-hint
            :hint="i18n('referente aos 12 meses anteriores')"
            ></v-currency-field>
          </v-flex>

          <v-flex class="xs12 lg6">
            <v-radio-group v-model="record.company_type" class="input-control-with-grow">
              <div :dark="isDark" class="text-color-gray">Forma*</div>
              <div class="flex-baseline-start-wrap">
                <v-radio :dark="isDark" :label="i18n('S/A')" value="sa"></v-radio>
                <v-radio :dark="isDark" :label="i18n('LTDA')" value="ltda"></v-radio>
                <v-radio :dark="isDark" :label="i18n('Associação')" value="associacao"></v-radio>
                <v-radio :dark="isDark" :label="i18n('Fundação')" value="fundacao"></v-radio>
              </div>
            </v-radio-group>
          </v-flex>

          <v-flex class="xs12 lg6">
            <v-radio-group v-model="record.activity_type" class="input-control-with-grow">
              <div :dark="isDark" class="text-color-gray">{{i18n('Atividade')}}*</div>
              <div class="flex-baseline-start-wrap">
                <v-radio :dark="isDark" :label="i18n('Sem fins lucrativos')" value="sem_fins_lucrativos"></v-radio>
                <v-radio :dark="isDark" :label="i18n('Capital aberto')" value="capital_aberto"></v-radio>
                <v-radio :dark="isDark" class="mr-0" :label="i18n('Outros')" value="outros"></v-radio>
              </div>
            </v-radio-group>
          </v-flex>
        </v-layout>

        <v-layout class="row wrap align-center">
          <v-flex class="title-form md1 lg12">
            <div class="headline">{{ i18n("Endereço") }}</div>
          </v-flex>
          <v-flex class="xs12 lg6">
            <v-autocomplete
            v-model="record.address_country"
            :errorMessages="errorMessagesFor('address_country')"
            :items="countries"
            :dark="isDark"
            :label="i18n('País')"
            ></v-autocomplete>
          </v-flex>
          <v-flex class="xs12 lg6">
            <v-text-field
            box
            :dark="isDark"
            v-model="record.address_postal_code"
            :errorMessages="errorMessagesFor('address_postal_code')"
            :mask="postalCodeMask"
            :label="i18n('CEP')"></v-text-field>
          </v-flex>
          <v-flex class="xs12 lg6">
            <v-text-field
            box
            :dark="isDark"
            v-model="record.address_street"
            :errorMessages="errorMessagesFor('address_street')"
            :label="i18n('Logradouro')"></v-text-field>
          </v-flex>
          <v-flex class="xs6 lg2">
            <v-text-field
            box
            :dark="isDark"
            v-model="record.address_number"
            :errorMessages="errorMessagesFor('address_number')"
            :label="i18n('Número')"></v-text-field>
          </v-flex>
          <v-flex class="xs6 lg4">
            <v-text-field
            box
            :dark="isDark"
            v-model="record.address_neighborhood"
            :errorMessages="errorMessagesFor('address_neighborhood')"
            :label="i18n('Bairro')"></v-text-field>
          </v-flex>
          <v-flex class="xs12 lg5">
            <v-text-field
            box
            :dark="isDark"
            v-model="record.address_complement"
            :errorMessages="errorMessagesFor('address_complement')"
            :label="i18n('Complemento')"></v-text-field>
          </v-flex>
          <v-flex class="xs12 lg4">
            <v-text-field
            box
            :dark="isDark"
            v-model="record.address_city"
            :errorMessages="errorMessagesFor('address_city')"
            :label="i18n('Cidade')"></v-text-field>
          </v-flex>
          <v-flex class="xs12 lg3">
            <v-text-field
            box
            :dark="isDark"
            v-model="record.address_state"
            :errorMessages="errorMessagesFor('address_state')"
            :label="i18n('Estado')"></v-text-field>
          </v-flex>
          <v-flex class="xs12 lg12 justify-flex-end" >
            <v-btn :dark="isDark" flat class="font-weight-black flex-1 secondary-btn-bg-color text-color-white" @click="$emit('cancelled')">{{i18n('Cancelar')}}</v-btn>
            <v-btn :dark="isDark" class="font-weight-black flex-2 btn-bg-color text-color-white" @click="skipAndScroll()">{{i18n('Prosseguir')}}</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-stepper-content>

    <v-stepper-content step="2">
      <v-container class="grid-list-lg" @click.prevent.stop="">
        <v-layout class="row wrap align-center" :key="index" v-for="(partner, index) in record.partners">
          <v-flex class="xs12 lg12 justify-flex-between">
            <span  :dark="isDark" class="flex-1-1 display-1 title-form">{{i18n('Sócio')}} {{index + 1}}</span>
            <v-btn :dark="isDark" outline @click.prevent="deletePartner(index)"><v-icon>delete</v-icon></v-btn>
          </v-flex>
          <v-flex class="xs12 lg4">
            <v-radio-group v-model="partner.kind" @change="partnerKindChange(index)">
              <div :dark="isDark" class="text-color-gray">{{i18n('Pessoa tipo')}}*</div>
              <div class="display-flex-baseline">
                <v-radio :dark="isDark" :label="i18n('Jurídica')" value="company"></v-radio>
                <v-radio :dark="isDark" :label="i18n('Física')" value="person"></v-radio>
              </div>
            </v-radio-group>
          </v-flex>
          <v-flex class="xs12 lg8" v-if="partner.kind == 'company'">
            <v-text-field
            box
            v-model="partner.name"
            :dark="isDark"
            :label="i18n('Razão Social')"></v-text-field>
          </v-flex>
          <v-flex class="xs12 lg8" v-if="partner.kind == 'person'">
            <v-text-field
            box
            v-model="partner.name"
            :dark="isDark"
            :label="i18n('Nome completo')"></v-text-field>
          </v-flex>
          <v-flex class="xs12 lg6" v-if="partner.kind == 'company'">
            <v-select
              box
              :label="i18n('Domicílio Fiscal')"
              append-icon="public"
              v-model="record.document_type"
              clearable
              @click:clear="record.document_type = null"
              :items="fiscalCountryItems"
            ></v-select>
          </v-flex>
          <v-flex class="xs12 lg4" v-if="partner.kind == 'person'">
            <v-select
              box
              :label="i18n('Nacionalidade')"
              append-icon="public"
              v-model="partner.document_type"
              clearable
              @click:clear="partner.document_type = null"
              :items="nationalitiesItems"
            ></v-select>
          </v-flex>
          <v-flex class="xs12 lg3" v-if="partner.kind == 'company'">
            <v-text-field
            box
            v-model="partner.document_number"
            :dark="isDark"
            :label="partner.document_type.toLowerCase() == 'tax_id' ? 'TAX ID*' : `${partner.document_type.toUpperCase()}*`"
            :mask="maskForDocumentNumber(partner.document_type)"
            ></v-text-field>
          </v-flex>
          <v-flex class="xs12 lg3" v-if="partner.kind == 'person'">
            <v-text-field
            box
            v-model="partner.document_number"
            :dark="isDark"
            :label="`${partner.document_type.toUpperCase()}*`"
            :mask="maskForDocumentNumber(partner.document_type)"
            ></v-text-field>
          </v-flex>
          <v-flex class="xs12 lg2">
            <v-currency-field
            v-bind="currency_config"
            box
            v-model="partner.percentage_share"
            :label="i18n('% de Participação*')"
            :dark="isDark"
            ></v-currency-field>
          </v-flex>
          <v-flex class="xs12 lg3" v-if="partner.kind == 'company'">
            <v-autocomplete
            v-model="partner.address_country"
            :items="countries"
            :dark="isDark"
            :label="i18n('País')"
            ></v-autocomplete>
          </v-flex>
          <v-flex class="xs12 lg3" v-if="partner.kind == 'person'">
            <v-autocomplete
            v-model="partner.address_country"
            :items="countries"
            :dark="isDark"
            :label="i18n('Nacionalidade')"
            ></v-autocomplete>
          </v-flex>
          <v-flex class="xs12 offset-lg3" lg6 v-if="partner.kind == 'company'">
            <v-radio-group v-model="partner.activity_type" class="input-control-with-grow">
              <div :dark="isDark" class="text-color-gray" slot="label">{{i18n('Atividade')}}*</div>
              <div class="display-flex-baseline flex-start-wrap">
                <v-radio :dark="isDark" :label="i18n('Sem fins lucrativos')" value="sem_fins_lucrativos"></v-radio>
                <v-radio :dark="isDark" :label="i18n('Capital aberto')" value="capital_aberto"></v-radio>
                <v-radio :dark="isDark" class="mr-0" :label="i18n('Outros')" value="outros"></v-radio>
              </div>
            </v-radio-group>
          </v-flex>
          <v-flex class="xs12">
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
        <v-layout class="row wrap">
          <v-flex class="xs12 lg12 d-flex">
            <v-btn :dark="isDark" class="upload-btn-bg-color" outline @click.prevent="addNewPartner"> {{addNewPartnerLabel}} </v-btn>
          </v-flex>
          <v-flex class="xs12 lg12 justify-flex-end">
            <v-btn :dark="isDark" flat class="font-weight-black font-weight-black flex-1 secondary-btn-bg-color text-color-white" @click="step = 1">{{i18n('Voltar')}}</v-btn>
            <v-btn :dark="isDark" class="font-weight-black flex-1 btn-bg-color text-color-white" @click="step = 3">{{i18n('Prosseguir')}}</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-stepper-content>
    <v-stepper-content step="3">
      <v-container class="grid-list-lg" @click="stopUnlessUploading">
        <v-layout class="row wrap">
          <v-flex :dark="isDark" class="xs12 lg12 display-1 title-form" >
            {{i18n('Documentos')}}
          </v-flex>
          <v-flex class="xs12 lg12">
            <Filetable
            :headers="headers"
            :items="record.documents"
            >
              <template v-slot:items="props">
                <td>{{ props.item.date || recordDate(props.item.inserted_at)}}</td>
                <td @click.prevent.stop="openOnNewWindow(props.item.file_url)">{{ props.item.filename || props.item.labels.join(',') }}</td>
              </template>
            </Filetable>
          </v-flex>
          <v-flex class="xs12 lg12 d-flex">
            <v-btn :dark="isDark" class="upload-btn-bg-color" v-if="!loadingFile" outline @click.prevent="pickFile"> {{i18n('Enviar arquivos')}} </v-btn>
            <v-btn :dark="isDark" v-if="loadingFile" outline class="upload-btn-bg-color"> {{i18n('Carregando arquivo... aguarde')}} </v-btn>
            <input
              :dark="isDark"
              type="file"
              multiple
              name="company_file"
              style="display: none"
              ref="company_upload_input"
              accept="*/*"
              @change="onFilePicked"
            />
          </v-flex>
          <v-flex class="xs12 lg12 justify-flex-end">
            <v-btn :dark="isDark" flat class="font-weight-black font-weight-black flex-1 secondary-btn-bg-color text-color-white" @click="step = 2">{{i18n('Voltar')}}</v-btn>
            <v-btn :dark="isDark" class="font-weight-black flex-1 btn-bg-color text-color-white" @click="createCompany" v-if="!admin && operation == 'create'">
              {{i18n('Cadastrar')}}
            </v-btn>
            <v-btn :dark="isDark" class="font-weight-black flex-1 btn-bg-color text-color-white" @click="step = 4" v-if="operation == 'update' && show_bank_accounts_tab">{{i18n('Prosseguir')}}</v-btn>
            <v-btn :dark="isDark" class="font-weight-black flex-1 btn-bg-color text-color-white" @click="updateCompany" v-if="operation == 'update' && !show_bank_accounts_tab">{{i18n('Atualizar')}}</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-stepper-content>

    <v-stepper-content :step="accounts_step_number" v-if="show_bank_accounts_tab">
      <v-container @click.prevent.stop="">
        <v-flex class="xs12 lg12 title-form display-1">
          {{ i18n("Canais Bancários") }}
        </v-flex>
        <BankAccounts :subject_id="subjectId" wait_for_subject :show_partner_facilita_bank_accounts="show_partner_facilita_bank_accounts" :show_external_bank_accounts="true" :show_admin_external_bank_account="show_admin_external_bank_account"/>
        <v-flex class="xs12 lg12 justify-flex-end">
          <v-btn :dark="isDark" flat class="font-weight-black flex-1 secondary-btn-bg-color text-color-white" @click="step = 3" v-if="operation == 'update'">
            {{i18n('Voltar')}}
          </v-btn>
          <v-btn :dark="isDark" class="flex-1 btn-bg-color text-color-white" @click="step = 1" v-if="operation == 'create'">
            {{i18n('Novo Cadastro')}}
          </v-btn>
          <v-btn :dark="isDark" class="flex-1 btn-bg-color text-color-white" @click="step = 5" v-if="admin">
            {{i18n('Prosseguir')}}
          </v-btn>
          <v-btn :dark="isDark" class="font-weight-black flex-1 btn-bg-color text-color-white" @click="updateCompany" v-if="!admin && operation == 'update'">
            {{i18n('Atualizar')}}
          </v-btn>
        </v-flex>
      </v-container>
    </v-stepper-content>

    <v-stepper-content :step="users_step_number" v-if="show_users_tab">
      <v-container @click.prevent.stop="">
        <v-flex class="xs12 lg12 title-form display-1">
          {{ i18n("Usuários Vinculados") }}
        </v-flex>
          <UsersList :users_list="this.record.users" :is_admin="admin" :company_id="this.record.id" />
        <v-flex class="xs12 lg12 justify-flex-end">
          <v-btn :dark="isDark" flat class="font-weight-black flex-1 secondary-btn-bg-color text-color-white" @click="step = 4">
            {{ i18n("Voltar") }}
          </v-btn>
          <v-btn :dark="isDark" class="font-weight-black flex-1 btn-bg-color text-color-white" @click="step = 6">
            {{ i18n("Prosseguir") }}
          </v-btn>
        </v-flex>
      </v-container>
    </v-stepper-content>

    <v-stepper-content :step="last_step_number" v-if="show_approval_tab">
      <v-container grid-list-lg @click.prevent.stop="">
        <v-layout row wrap v-if="show_reprove_form == false">
          <v-flex class="xs12 sm6 display-1" v-if="operation == 'update'">
            {{i18n('Atualizar/Aprovar')}}
          </v-flex>
          <v-flex xs12 sm6 mt-3 text-sm-right subtitle-1 style="color: var(--background-color)">
            Total movimentado: {{l(record.transaction_balance, customer_currency)}}
          </v-flex>
          <v-flex class="xs12 lg12">
            <v-radio-group v-model="record.clearance_level" class="input-control-with-grow">
              <div slot="label">{{i18n('Autorização')}}*</div>
              <div class="flex-baseline-start-wrap">
                <v-radio :label="i18n('Não autorizado')" value="0"></v-radio>
                <v-radio :label="i18n('Aprovado Nivel 1')" value="1"></v-radio>
                <v-radio :label="i18n('Aprovado Nivel 2')" value="2"></v-radio>
                <v-flex v-if="record.clearance_level > 1">
                  <v-checkbox
                    append-icon="vertical_align_top"
                    v-model="enableTransactionLimit"
                    hide-details
                    label="Definir limite de total transacionado">
                  </v-checkbox>
                  <v-currency-field
                    :label="customer_currency"
                    v-if="enableTransactionLimit"
                    v-bind="currency_config"
                    v-model="record.transaction_limit">
                  </v-currency-field>
                </v-flex>
              </div>
            </v-radio-group>
          </v-flex>
          <v-flex class="xs12 lg12 justify-flex-end">
            <v-btn flat :dark="isDark" class="font-weight-black flex-2 secondary-btn-bg-color text-color-white" @click="step = last_step_number - 1">{{i18n('Voltar')}}</v-btn>
            <v-btn class="font-weight-black flex-3 btn-bg-color text-color-white" :dark="isDark" @click="updateCompany" v-if="operation == 'update'">
              {{i18n('Atualizar')}}
            </v-btn>
            <v-btn class="font-weight-black hidden-xs-only flex-1 btn-bg-red" :dark="isDark" @click="showRejectReasonForm" v-if="operation == 'update'">
              {{i18n('Reprovar')}}
            </v-btn>
          </v-flex>
          <v-flex class="xs12 lg12 hidden-sm-and-up justify-flex-end"  v-if="operation == 'update'">
            <v-btn class="font-weight-blackflex-1 btn-bg-red" :dark="isDark" @click="showRejectReasonForm">
              {{i18n('Reprovar')}}
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout class="row wrap" v-if="show_reprove_form == true">
          <v-flex class="xs12 lg12 display-1" >
            {{i18n('Reprovar Cadastro')}}
          </v-flex>
          <v-flex class="xs12 lg6">
            <v-checkbox v-model="rejected_items" :label="i18n('Documento rejeitado')" value="photo_id_rejected" :disabled="disabledWhen('photo_id_missing')"></v-checkbox>
            <v-checkbox v-model="rejected_items" :label="i18n('Documento não enviado')" value="photo_id_missing" :disabled="disabledWhen('photo_id_rejected')"></v-checkbox>
            <v-checkbox v-model="rejected_items" :label="i18n('Declaração de IR insuficiente')" value="tax_declaration_insufficient"></v-checkbox>
          </v-flex>
          <v-flex class="xs12 lg6">
            <v-checkbox v-model="rejected_items" :label="i18n('Comprovante de residência rejeitado')" value="proof_of_address_rejected" :disabled="disabledWhen('proof_of_address_missing')"></v-checkbox>
            <v-checkbox v-model="rejected_items" :label="i18n('Comprovante de residência não enviado')" value="proof_of_address_missing" :disabled="disabledWhen('proof_of_address_rejected')"></v-checkbox>
            <v-checkbox v-model="rejected_items" :label="i18n('Endereço não informado')" value="missing_address_info"></v-checkbox>
          </v-flex>
          <v-flex class="xs12 lg12">
            <v-textarea
            box
            name="reprove_reason"
            :label="i18n('Motivo Reprovação')+'*'"
            v-model="reprove_reason"
            ></v-textarea>
          </v-flex>
          <v-flex class="xs12 lg12 justify-flex-end">
            <v-btn flat class="font-weight-black flex-2 secondary-btn-bg-color text-color-white" @click="hideRejectReasonForm">{{i18n('Voltar')}}</v-btn>
            <v-btn class="font-weight-black hidden-xs-only flex-1 btn-bg-red" :dark="isDark" @click="reproveCompany" v-if="operation == 'update'">
              {{i18n('Reprovar')}}
            </v-btn>
          </v-flex>
          <v-flex class="xs12 lg12 justify-flex-end hidden-sm-and-up" v-if="operation == 'update'">
            <v-btn :dark="isDark" class="font-weight-black flex-1 btn-bg-red" @click="reproveCompany">
              {{i18n('Reprovar')}}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-stepper-content>
  </v-stepper>
</template>

<script>
  import utils from "./shared/Utils"
  import countries from "./shared/Countries"
  import activities from "./shared/CompanyActivities"
  import BankAccounts from "./components/BankAccounts"
  import UsersList from './components/Users.vue'
  import Filetable from "./components/DefaultDataTable"
  import CountryPhoneCodes from "./shared/CountryPhoneCodes"

  export default {
    name: 'AdminCompanyForm',
    components: {
      BankAccounts, UsersList, Filetable
    },
    props: {
      record: {
        type: Object
      },
      admin: {
        type: Boolean,
        default: false
      },
      subject: {
        type: Boolean,
        default: false
      },
      operation: {
        type: String
      },
      isDark: {
        type: Boolean,
        default: false
      }
    },
    data(vm) {
      return {
        step: 1,
        activities,
        base_url: '',
        countries,
        currency_config: {
          decimal: ',',
          thousands: '.',
          precision: 2
        },
        errors: {},
        loadingFile: false,
        recentlyCreatedId: "",
        display_feedback: false,
        enableTransactionLimit: null,
        creationDateFormatted: vm.formatDate(vm.record.creation_date),
        max_file_size: 20000000,
        show_reprove_form: false,
        transactionTotalBRL: 0,
        transactionTotals: {},
        reprove_reason: '',
        rejected_items: [],
        fiscalCountryItems: [
          {value: 'cnpj', text: this.i18n('Brasil')},
          {value: 'rfc', text: this.i18n('México')},
          {value: 'nit', text: this.i18n('Colômbia')},
          {value: 'rut', text: this.i18n('Chile')},
          {value: 'tax_id', text: this.i18n('Outro')},
        ],
        nationalitiesItems: [
          {value: 'cpf', text: this.i18n('Brasileira')},
          {value: 'curp', text: this.i18n('Mexicana')},
          {value: 'cc', text: this.i18n('Colombiana')},
          {value: 'rut', text: this.i18n('Chilena')},
          {value: 'passport', text: this.i18n('Outra')},
        ],
        headers: [
          { text: this.i18n('Data'), align: 'left', value: 'inserted_at', sortable: true },
          { text: this.i18n('File name'), value: 'inserted_at', align: 'left', sortable: false }
        ]
      }
    },
    beforeMount() {
      this.fixPartnersPercentageShare(this.record)
      this.record.net_value = this.record.net_value || ""
      this.record.net_monthly_average_income = this.record.net_monthly_average_income || ""
      this.record.transaction_limit = this.record.transaction_limit || ""
      this.enableTransactionLimit = this.record.transaction_limit > 0
    },
    mounted() {
      if (this.admin) {
        this.base_url = this.$root.urls.admin_companies
      } else if (this.subject) {
        this.base_url = this.$root.urls.customer__companies
        if (this.record.id) {
          this.loadTransactionTotals()
        }
      } else {
        this.base_url = this.$root.urls.companies
      }

      if (this.operation == 'create') {
        this.record.fiscal_country = 'Brasil'
        this.record.activity_type = 'outros'
        this.record.company_type = 'ltda'
      }
      this.record.clearance_level = this.record.clearance_level + ''

      if (this.record.documents) {
        this.record.documents.forEach((file, index)=>{
          if (!file.file_url) {
            this.createFileUrl(file, index)
          }
        })
      }
    },
    computed: {
      subjectId() {
        return this.subject && (this.record.id || this.recentlyCreatedId) || ''
      },
      postalCode() {
        return this.record.address_postal_code
      },
      postalCodeMask() {
        if (this.record.address_country == 'Brasil') {
          return '##.###-###'
        } else {
          return ''
        }
      },
      addNewPartnerLabel() {
        if (this.record.partners && this.record.partners.length > 0) {
          return this.i18n('Cadastrar Outro Sócio')
        }
        return this.i18n('Cadastrar Sócio')
      },
      displayTotals() {
        return !this.admin && this.operation != 'create'
      },
      hasRegisteredUsers() {
        return !!this.record.users && this.record.users.length > 0
      },
      show_bank_accounts_tab() {
        return this.subject
      },
      show_users_tab() {
        return this.admin && this.hasRegisteredUsers
      },
      show_partner_facilita_bank_accounts() {
        return this.admin && this.hasRegisteredUsers
      },
      show_admin_external_bank_account() {
        return this.admin
      },
      show_approval_tab() {
        return this.admin && this.subject
      },
      accounts_step_number() {
        return 4
      },
      users_step_number() {
        return this.show_bank_accounts_tab ? this.accounts_step_number + 1 : this.accounts_step_number
      },
      last_step_number() {
        return this.show_users_tab ? this.users_step_number + 1 : this.users_step_number
      },
      getCountryCodes() {
        return CountryPhoneCodes
      },
      customer_currency() {
        switch (this.record.document_type) {
          case 'cnpj':
            return 'BRL'
          case 'rfc':
            return 'MXN'
          case 'nit':
            return 'COP'
          case 'rut':
            return 'CLP'
          default:
            return 'USD'
        }
      },
    },
    watch: {
      'record.creation_date'(new_val) {
        this.creationDateFormatted = this.formatDate(new_val)
      },
      creationDateFormatted(new_val) {
        this.record.creation_date = this.parseDate(new_val)
      },
      postalCode(new_postal_code, old_postal_code) {
        if (new_postal_code != old_postal_code) {
          let postal_code = new_postal_code.replace('.','').replace('-','')

          if (this.record.address_country == 'Brasil' && postal_code.length == 8) {
            let successCallback = (response) => {
              this.$set(this.record, 'address_street', response.body.logradouro)
              this.$set(this.record, 'address_city', response.body.cidade)
              this.$set(this.record, 'address_state', response.body.estado)
            }

            let errorCallback = (response) => {
            }

            this.$http.get(`${this.$root.urls.cep_api}${postal_code}`).then(successCallback, errorCallback)
          }
        }
      }
    },
    methods: {
      i18n(str) {
        return this.$root.l(str)
      },
      recordDate(date) {
        return utils.dbDateTimeToHuman(date).toString()
      },
      disabledWhen(value) {
        return this.rejected_items.includes(value)
      },
      parseDate(human_format_date) {
        return utils.humanDateToDb(human_format_date)
      },
      formatDate(db_format_date) {
        return utils.dbDateToHuman(db_format_date)
      },
      maskForDocumentNumber(document_type) {
        return utils.maskForDocumentType(document_type.toLowerCase())
      },
      errorMessagesFor(field) {
        if (this.errors[field]) {
          return this.errors[field]
        } else {
          return []
        }
      },
      copyIdtoClipboard() {
        navigator.clipboard.writeText(this.record.id).then(() => {
          this.display_feedback = true
        })
      },
      stopUnlessUploading(e) {
        if (e.target.type === 'file') {
          return true
        } else {
          e.preventDefault()
          return false
        }
      },
      createFileUrl(file, index){
        let successCallback = (response) => {
          let { file_data } = response.body.data
          let { file_type } = file
          this.record.documents[index].file_url =  utils.b64ToUrl(file_data, file_type)
        }
        let errorCallback = (response) => {
          console.log(response)
        }
        let token = this.$cookies.get("api_token")
        this.$http.get(`${this.$root.urls.customer__subject}${this.record.id}/documents/${file.id}`
        ,{ headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
      },
      pickFile(e) {
        this.$refs.company_upload_input.click()
        e.stopPropagation()
      },
      openOnNewWindow(url) {
        window.open(url, '_blank')
      },

      onFilePicked(e) {
        const batch_size = 20
        const files = e.target.files;

        if (files.length > 0 && files.length <= batch_size) {
          this.loadingFile = true;
          let filesProcessed = 0;
          let totalFiles = files.length;

          Array.from(files).forEach((file) => {
            let filename = file.name;

            if (filename.lastIndexOf(".") <= 0) {
              alert(this.i18n("Arquivo") + ' "' + filename + '" ' + this.i18n("é inválido"));
              filesProcessed++;
              if (filesProcessed === totalFiles) {
                this.loadingFile = false;
              }
              return;
            }

            const fr = new FileReader();
            fr.readAsDataURL(file);

            fr.addEventListener("load", () => {
              this.$nextTick(() => {
                let ext = filename.split(".").pop();
                let labels = [filename];
                let data = fr.result.match(/^[^,]*,(.*)$/)[1];
                let file_type = fr.result.match(/^data:([^;]*);.*$/)[1];
                let date = this.recordDate(Date.now());
                let size = data.length;

                if (size > this.max_file_size) {
                 alert(
                      ' "' +
                      filename +
                      '": ' +
                      this.i18n("Arquivos maiores que 14.9Mb não podem ser enviados")
                  );
                  filesProcessed++;
                  if (filesProcessed === totalFiles) {
                    this.loadingFile = false;
                  }
                  return;
                }

                const payload = {
                  file: {
                    name: filename,
                    ext,
                    data,
                  },
                };

                let uploadSuccess = (response) => {
                  if (response.body.data) {
                    let file_url =
                      this.$root.urls.public_uploads +
                        response.body.data.id +
                        "." +
                        response.body.data.ext;
                    this.record.documents = this.record.documents || [];
                    this.record.documents.push({
                      filename,
                      size,
                      labels,
                      file_url,
                      file_type,
                      date,
                    });
                  }
                  filesProcessed++;
                  if (filesProcessed === totalFiles) {
                    this.loadingFile = false;
                  }
                };

                let uploadError = (response) => {
                  alert(
                    this.i18n("Não foi possível completar o upload do arquivo") +
                      ' "' +
                      filename +
                      '"'
                  );
                  filesProcessed++;
                  if (filesProcessed === totalFiles) {
                    this.loadingFile = false;
                  }
                };

                this.uploadFile(payload, uploadSuccess, uploadError);
              });
            });
          });
        } else {
          alert(this.i18n('Selecione no máximo') + ' ' + batch_size + ' ' + this.i18n('arquivos'));
          this.fileName = "";
          this.fileUrl = "";
        }
      },
      uploadFile(payload, successCallback, errorCallback) {
        const token = this.$cookies.get('api_token')
        this.$http.post(this.$root.urls.upload, payload, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
      },
      addNewPartner(e) {
        let new_partner = {
          kind: 'person',
          name: '',
          document_type: 'cpf',
          document_number: '',
          address_country: '',
          percentage_share: ''
        }
        let partners = this.record.partners || []
        partners.push(new_partner)
        this.$set(this.record, 'partners', partners)
      },
      deletePartner(index) {
        this.record.partners.splice(index, 1)
      },
      addNewReference(e) {
        let new_reference = {
          kind: 'financial_institution',
          bank_number: '',
          branch_number: '',
          account_number: '',
          creation_year: '',
        }
        let references = this.record.references || []
        references.push(new_reference)
        this.$set(this.record, 'references', references)
      },
      deleteReference(index) {
        this.record.references.splice(index, 1)
      },
      loadTransactionTotals() {
        let successCallback = (response) => {
          if (response.body.data.length) {
            this.transactionTotals = response.body.data
            this.transactionTotalBRL = this.transactionTotals.reduce(
              (total, transaction) => { return total + parseFloat(transaction.value) }, 0
            )
          }
        }

        let errorCallback = (response) => {
          console.log(response)
        }

        const token = this.$cookies.get('api_token')
        this.$http.get(
          `${this.$root.urls.customer__subject}${this.record.id}/transaction_values`,
          { headers: { Authorization: `Bearer ${token}` }}
        ).then(successCallback, errorCallback)
      },
      updateCompany(e) {
        if (!this.enableTransactionLimit || this.record.clearance_level < 2) this.record.transaction_limit = ''
        const payload = { company: this.record }

        let successCallback = (response) => {
          this.$emit('onUpdate')
        }

        let errorCallback = (response) => {
          if (response.body.errors) {
            let errors = response.body.errors

            for (let field in errors) {
              errors[field] = errors[field].map((error_msg)=>{
                return utils.translateErrorMessage(error_msg, this.$root.lang)
              })
            }

            this.errors = errors
            this.step = 1
          }
        }
        this.errors = {}
        const token = this.$cookies.get('api_token')
        const company_id = this.record.id
        this.$http.put(this.base_url + company_id, payload, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
      },
      createCompany(e) {
        const payload = { company: this.record }

        let successCallback = (response) => {
          if (response.body.data) {
            this.$emit('onCreate', response.body.data)
            this.recentlyCreatedId = response.body.data.id
            this.errors = {}
            this.step = 4
          } else {
            console.log(response)
          }
        }

        let errorCallback = (response) => {
          if (response.body.errors) {
            let errors = response.body.errors

            for (let field in errors) {
              errors[field] = errors[field].map((error_msg)=>{
                return utils.translateErrorMessage(error_msg, this.$root.lang)
              })
            }

            this.errors = errors
            this.step = 1
          }
        }

        this.errors = {}
        const token = this.$cookies.get('api_token')
        this.$http.post(this.base_url, payload, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
      },
      partnerKindChange(index) {
        let current_partner = this.record.partners[index]

        if (current_partner.kind == 'company') {
          this.$set(current_partner, 'document_type', 'cnpj')
        } else {
          this.$set(current_partner, 'document_type', 'cpf')
        }

        this.$set(this.record.partners, index, current_partner)
      },
      showRejectReasonForm(e) {
        this.show_reprove_form = true
      },
      hideRejectReasonForm(e) {
        this.show_reprove_form = false
      },
      reproveCompany(e) {
        const payload = { reason: this.reprove_reason, items: this.rejected_items }

        let successCallback = (response) => {
          this.$emit('onReprove')
        }

        let errorCallback = (response) => {
          console.log('error')
          console.log(response)
        }

        const token = this.$cookies.get('api_token')
        const url = `${this.$root.urls.admin_companies}${this.record.id}/reprove`
        this.$http.post(url, payload, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
      },
      l(number_value, currency) {
        return utils.currencyToLocal(number_value, currency)
      },
      skipAndScroll() {
        this.step = 2;
        this.$refs.formHeader.scrollIntoView();
      },
      fixPartnersPercentageShare(record) {
        if (record.partners != null) {
          record.partners.forEach(partner => {
            partner.percentage_share = this.toFixedOrDefault(partner.percentage_share, '0.00')
          })
        }
      },
      toFixedOrDefault(value, defaultValue) {
        return value && Number(value).toFixed(2) || defaultValue
      },
    },
    metaInfo: {
      title: "Facilita Pay"
    }
  }
</script>

<style scoped>

.dark-mode {
  background: var(--background-color) !important;
}

.dark-mode .text-color-gray{
  color: white !important;
}

.dark-mode >>> .v-stepper__step span.primary {
  background-color: var(--secondary-button-background-color) !important;
}

.v-stepper__step >>> span.primary {
  background-color: var(--background-color) !important;
}

.dark-mode >>>.v-stepper__step .v-stepper__label {
  color: white !important;
}

.dark-mode >>> .v-stepper__label{
 color: white !important;
}

.dark-mode .title-form {
  color: var(--secondary-button-background-color) !important;
}

.btn-style, .btn-style--secondary {
  height: 56px;
}

.btn-style {
  background-color: var(--primary-button-background-color)!important;
}

.btn-style--secondary {
  background-color: var(--secondary-button-background-color)!important;
}

.v-stepper__step__step.step_bg_color {
  background-color: var(--secondary-button-background-color);
}

.v-stepper__step--active .v-stepper__label {
  color: var(--background-color)!important;
}
li.documentList {
  color: #333;
  cursor: pointer;
}

.br-10 {
  border-radius: 10px;
}

.cursor-type {
  cursor: default;
}

.justify-flex-end {
  display: flex;
  justify-items: flex-end;
}

.p-relative {
  position: relative;
}

.width-position {
  width: 270px;
  position: absolute;
  top: 30px;
  left: 0px;
}

.flex-align {
  display: flex;
  align-items: baseline;
}

.flex-1 {
  flex: 1;
}

.flex-2 {
  flex: 2;
}

.flex-3 {
  flex: 3;
}

.dark-mode .upload-btn-bg-color{
  color: white !important;
}

.upload-btn-bg-color{
  color: var(--background-color) !important;
}

.secondary-btn-bg-color{
  color: var(--background-color) !important;
}

.btn-bg-color {
  background-color: var(--secondary-button-background-color) !important;
}

.flex-space-between {
  display: flex;
  justify-content: space-between;
}

.secondary-btn-bg-color {
  color: var(--background-color) !important;
}

.text-color-white{
  color: white
}

.dark-mode .text-color-white{
  color: white !important;
}

.text-color-gray {
  color: gray !important;
}

.dark-mode .text-color-gray {
  color: white !important;
}

.display-flex-baseline {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.title-form {
  color: #44517B;
}

.flex-start-wrap {
  justify-content: flex-start;
  flex-wrap: wrap;
}

.btn-bg-color {
  background-color: var(--secondary-button-background-color) !important;
}

.align-center {
  align-items: center;
}

.justify-flex-between{
  display: flex;
  justify-content: space-between;
}

.btn-bg-red {
  background-color: var(--light-red-color) !important;
  color: white !important;
}

.flex-baseline-start-wrap {
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.position-input-form {
  width: 270px;
  color: #b3b3b3;
  position: absolute;
  top: 30px;
  left: 0px;
}

.cursor-type {
  cursor: default;
}

.position-relative {
  position: relative;
}

.flex-1-1 {
  flex: 1 1;
}

.padding-bottom-liquid {
 .v-text-field__details{
  margin-bottom: 12px
 }
}
</style>



// WEBPACK FOOTER //
// src/AdminCompanyForm.vue